exports.network = 'WRT'

exports.epoch = 946684800

exports.transactionResults = {
  SUCCESS: 'tesSUCCESS'
}

exports.nativeCurrency = 'WRT'

exports.precision = 6



//////////////////
// WEBPACK FOOTER
// ./src/helpers/constants.js
// module id = 224
// module chunks = 0